import type { RouteRecordRaw } from "vue-router";

export const websiteRoutes: RouteRecordRaw[] = [
  {
    path: "/website/info",
    name: "website-info",
    component: () => import("./info/WebsiteInfoPage.vue"),
    meta: {
      namespace: "website",
      title: "tools_meta.website_prefix",
    },
  },
  {
    path: "/website/pages",
    name: "website-index",
    component: () => import("./pages/WebPageListPage.vue"),
    meta: {
      requiresAuth: true,
      namespace: "website",
      title: "tools_meta.website_prefix",
    },
  },
  {
    path: "/website/pages/:id",
    name: "website-show",
    component: () => import("./pages/WebPageLayout.vue"),
    meta: {
      requiresAuth: true,
      namespace: "website",
      title: "tools_meta.website_prefix",
    },
    children: [
      {
        path: "settings",
        name: "website-settings",
        component: () => import("./pages/[id]/settings.vue"),
        meta: {
          requiresAuth: true,
          namespace: "website",
          title: "tools_meta.website_prefix",
        },
      },
      {
        path: "share",
        name: "website-share",
        component: () => import("./pages/[id]/share.vue"),
        meta: {
          requiresAuth: true,
          namespace: "website",
          title: "tools_meta.website_prefix",
        },
      },
    ],
  },
  {
    path: "/website/public_pages/:id",
    name: "website-public-show",
    component: () => import("./public_pages/[id]/PublicWebPagePage.vue"),
    meta: {
      namespace: "website",
    },
  },
];
